import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralizeYear'
})
export class PluralizeYearPipe implements PipeTransform {

  transform(durationInDays: number): string {
    const years = Math.floor(durationInDays / 365); // Convertit en années
    const label = years > 1 ? 'ans' : 'an'; // Change "an" en "ans" si nécessaire
    return `${years} ${label}`;
  }

}
